import { Typography } from '@mui/material';
import useCustomTranslation from '@hooks/useCustomTranslation';

import styles from './ParticipantFinishScreen.module.scss';

const ParticipantFinishScreen = () => {
  const { getTranslation } = useCustomTranslation();

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <Typography variant="overline" color="textSecondary">
          {getTranslation('CvaInput.Bye', 'participantFinishMessage')}
        </Typography>
      </div>
    </div>
  );
};

export default ParticipantFinishScreen;
